/* ==========================================================================
   GemofU: product photos - tap to zoom, a simple "‹ 2 / 7 ›" pager, and no
   chain length guide in the quick view.

   - On phones Forge ignores a tap on the photo itself (only the small zoom
     button opened the enlarged view), so the photo seemed "stuck". A tap
     (not a swipe) on the photo now opens the same zoom view.
   - The big maroon round arrows sat on top of the photo. They and the dots
     are hidden (assets/gou-photos.css) and replaced by a small pager under
     the photo, like the running site.
   - The product page leaves the shared chain length guide out in Liquid
     (snippets/product-scroll-gallery.liquid). The quick view gallery is
     built by another snippet, so the slide is taken out here.
   ========================================================================== */
(function () {
  'use strict';

  var GUIDE = /chain length guide/i;

  function isTouch() {
    try {
      if (window.WAU && WAU.Helpers && typeof WAU.Helpers.isDevice === 'function') return !!WAU.Helpers.isDevice();
    } catch (e) {}
    return window.matchMedia && window.matchMedia('(hover: none)').matches;
  }

  /* ---- Tap the photo to zoom ------------------------------------------- */
  var down = null;
  document.addEventListener('pointerdown', function (e) {
    down = { x: e.clientX, y: e.clientY };
  }, true);

  document.addEventListener('click', function (e) {
    var img = e.target && e.target.closest ? e.target.closest('.product-main-images img.product__image') : null;
    if (!img) return;
    // On a computer the grid photos already open the zoom themselves (they
    // carry js-zoom-btn); the big photo of the thumbnail layout does not.
    if (!isTouch() && img.classList.contains('js-zoom-btn')) return;
    if (down && Math.abs(e.clientX - down.x) + Math.abs(e.clientY - down.y) > 12) return; // a swipe
    var box = img.closest('.product-gallery__media-container');
    var btn = box && box.querySelector('.product-gallery__zoom-btn');
    if (btn) btn.click();
  }, true);

  /* ---- Pager ------------------------------------------------------------ */
  var CHEV_L = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function dropGuide(carousel, flkty) {
    var gone = [];
    flkty.cells.forEach(function (cell) {
      var img = cell.element.querySelector('img');
      if (img && GUIDE.test(img.getAttribute('alt') || '')) gone.push(cell.element);
    });
    if (gone.length && gone.length < flkty.cells.length) flkty.remove(gone);
  }

  function bind(carousel) {
    var flkty = window.Flickity && window.Flickity.data ? window.Flickity.data(carousel) : null;
    if (!flkty || !flkty.cells) return;
    if (carousel._gouFlkty === flkty) return;
    carousel._gouFlkty = flkty;

    dropGuide(carousel, flkty);

    var pager = carousel.parentNode.querySelector(':scope > .gou-pager:not(.gou-pager--swipe)');
    if (!pager) {
      pager = document.createElement('div');
      pager.className = 'gou-pager';
      pager.innerHTML =
        '<button type="button" class="gou-pager__btn" data-dir="prev" aria-label="Previous photo">' + CHEV_L + '</button>' +
        '<span class="gou-pager__count" aria-live="polite"></span>' +
        '<button type="button" class="gou-pager__btn" data-dir="next" aria-label="Next photo">' + CHEV_R + '</button>';
      carousel.insertAdjacentElement('afterend', pager);
    }

    pager.onclick = function (e) {
      var b = e.target.closest ? e.target.closest('.gou-pager__btn') : null;
      if (!b) return;
      e.preventDefault();
      var f = carousel._gouFlkty;
      if (!f) return;
      if (b.getAttribute('data-dir') === 'prev') f.previous(true); else f.next(true);
    };

    function update() {
      var total = flkty.cells.length;
      pager.hidden = total < 2;
      pager.querySelector('.gou-pager__count').textContent = (flkty.selectedIndex + 1) + ' / ' + total;
    }
    flkty.on('select', update);
    flkty.on('cellChange', update);
    update();
  }

  function scan() {
    // Main photo carousel only - never the strip of small thumbnails.
    document.querySelectorAll('.product-main-images .flickity-enabled:not(.carousel-nav)').forEach(bind);
    // Pagers left behind by a carousel that was taken down (desktop resize).
    document.querySelectorAll('.gou-pager:not(.gou-pager--swipe)').forEach(function (p) {
      var prev = p.previousElementSibling;
      if (!prev || !prev.classList.contains('flickity-enabled')) p.remove();
    });
  }

  var t = null;
  function start() {
    scan();
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(scan, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ==========================================================================
   GemofU: home slideshow keeps changing on its own.
   Flickity stops autoplay for good the first time the slideshow is touched.
   On a phone that happens almost at once - starting a scroll with a thumb on
   the big photo counts as a touch - so the pictures never changed again.
   Here autoplay starts again a moment after any swipe, tap or arrow press.
   ========================================================================== */
(function () {
  'use strict';

  function hook(el) {
    var f = window.Flickity && window.Flickity.data ? window.Flickity.data(el) : null;
    if (!f || !f.options || !f.options.autoPlay || el._gouAutoplay === f) return;
    el._gouAutoplay = f;
    var t = null;
    function resume() {
      clearTimeout(t);
      t = setTimeout(function () {
        try { f.playPlayer(); } catch (e) {}
      }, 1500);
    }
    f.on('pointerUp', resume);
    f.on('dragEnd', resume);
    f.on('staticClick', resume);
    f.on('select', resume);
  }

  function scan() {
    document.querySelectorAll('.section-slideshow .flickity-enabled').forEach(hook);
  }

  var t = null;
  function start() {
    scan();
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(scan, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ==========================================================================
   GemofU: collection pages - the search bar moves off the banner photo
   (where it covered the jewellery) into the spot under the banner where
   the collection's description sentence was; that sentence is hidden
   (assets/gou-photos.css). The bar itself comes from assets/gou-search.js,
   which loads after this file, so this waits for it to appear.
   ========================================================================== */
(function () {
  'use strict';
  if (!document.body || !/\btemplate-collection\b/.test(document.body.className)) return;

  function place() {
    var bar = document.querySelector('.gou-inline-search');
    if (!bar) return false;
    if (bar.classList.contains('gou-inline-search--below')) return true;
    var desc = document.querySelector('#collection-page .collection-description');
    var host = desc ? desc.parentNode : document.querySelector('#collection-page .grid__wrapper');
    if (!host) return false;
    host.insertBefore(bar, desc || host.firstChild);
    bar.classList.add('gou-inline-search--below');
    return true;
  }

  function start() {
    if (place()) return;
    var mo = new MutationObserver(function () {
      if (place()) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ==========================================================================
   GemofU: suggestions under the category search bar while typing.
   - On first use the shop's product list is loaded once (/products.json,
     kept for the visit in sessionStorage) so matching is instant and covers
     every piece: names starting with what was typed come first ("green" ->
     Green Moissanite Necklace Set, Green and Red Invisible Chain), then names
     with a word starting with it, then names containing it, then pieces that
     only match on type or tag.
   - Shopify's predictive search (/search/suggest.json) adds matching
     categories, and stands in for the list until it has loaded.
   - Arrow keys move through the list, Enter opens the highlighted piece,
     Esc closes it. Enter with nothing highlighted searches as before.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'gou_sug_index_v1';
  var index = null, loading = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function rx(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function price(p) {
    var n = parseFloat(p);
    if (isNaN(n)) return '';
    return 'Rs. ' + Math.round(n).toLocaleString('en-IN'); // whole rupees, no paise
  }
  function mark(title, q) {
    var words = q.split(/\s+/).filter(Boolean).map(rx);
    if (!words.length) return esc(title);
    var re = new RegExp('(' + words.join('|') + ')', 'ig');
    return esc(title).replace(re, '<mark>$1</mark>');
  }

  function slim(p) {
    var min = null, avail = false;
    (p.variants || []).forEach(function (v) {
      var n = parseFloat(v.price);
      if (!isNaN(n) && (min === null || n < min)) min = n;
      if (v.available) avail = true;
    });
    var img = p.images && p.images[0] ? p.images[0].src : '';
    return {
      t: p.title || '',
      u: '/products/' + p.handle,
      p: min,
      a: avail,
      i: img,
      x: ((p.product_type || '') + ' ' + (p.tags || []).join(' ')).toLowerCase()
    };
  }

  function loadIndex() {
    if (index) return Promise.resolve(index);
    if (loading) return loading;
    try {
      var cached = sessionStorage.getItem(KEY);
      if (cached) { index = JSON.parse(cached); return Promise.resolve(index); }
    } catch (e) {}
    loading = fetch('/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        index = (j.products || []).map(slim);
        try { sessionStorage.setItem(KEY, JSON.stringify(index)); } catch (e) {}
        return index;
      })
      .catch(function () { loading = null; return null; });
    return loading;
  }

  function localMatch(q) {
    if (!index) return null;
    var words = q.split(/\s+/).filter(Boolean);
    var out = [];
    index.forEach(function (it, n) {
      var t = it.t.toLowerCase().replace(/\s+/g, ' ');
      var r;
      if (t.indexOf(q) === 0) r = 0;
      else if (new RegExp('(^|[^a-z0-9])' + rx(q)).test(t)) r = 1;
      else if (words.every(function (w) { return new RegExp('(^|[^a-z0-9])' + rx(w)).test(t); })) r = 2;
      else if (t.indexOf(q) !== -1) r = 3;
      else if (words.every(function (w) { return t.indexOf(w) !== -1 || it.x.indexOf(w) !== -1; })) r = 4;
      else return;
      out.push({ it: it, r: r, a: it.a ? 0 : 1, n: n });
    });
    out.sort(function (a, b) { return a.r - b.r || a.a - b.a || a.n - b.n; });
    return out.slice(0, 6).map(function (o) {
      return { title: o.it.t, url: o.it.u, price: o.it.p, available: o.it.a, image: o.it.i };
    });
  }

  function remoteProducts(q, res) {
    return (res.products || []).map(function (p, i) {
      var t = (p.title || '').toLowerCase();
      var r = t.indexOf(q) === 0 ? 0 : (new RegExp('(^|[^a-z0-9])' + rx(q)).test(t) ? 1 : 2);
      return { title: p.title, url: p.url, price: p.price, available: p.available, image: p.image || (p.featured_image && p.featured_image.url) || '', _r: r, _i: i };
    }).sort(function (a, b) { return a._r - b._r || a._i - b._i; }).slice(0, 6);
  }

  function attach(form) {
    if (form._gouSug) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    form._gouSug = true;
    form.classList.add('gou-sug-host');

    var box = document.createElement('div');
    box.className = 'gou-sug';
    box.id = 'gou-sug-' + Math.random().toString(36).slice(2, 8);
    box.setAttribute('role', 'listbox');
    box.hidden = true;
    form.appendChild(box);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', box.id);

    var timer = null, current = '', ctrl = null, active = -1, cats = [], remote = null;

    function items() { return box.querySelectorAll('.gou-sug__item'); }
    function setActive(i) {
      var list = items();
      if (!list.length) return;
      if (i < 0) i = list.length - 1;
      if (i >= list.length) i = 0;
      list.forEach(function (el, n) { el.classList.toggle('is-active', n === i); });
      active = i;
      list[i].scrollIntoView({ block: 'nearest' });
    }
    function close() { box.hidden = true; active = -1; }
    function focused() { return document.activeElement === input || form.contains(document.activeElement); }

    function render() {
      var q = current;
      if (q.length < 2) { box.innerHTML = ''; close(); return; }
      var prods = localMatch(q);
      if (prods === null) prods = remote ? remote : null;
      if (prods === null) return; // nothing to show yet
      var html = '';
      if (cats.length) {
        html += '<div class="gou-sug__cats">';
        cats.forEach(function (c) {
          html += '<a class="gou-sug__cat" href="' + esc(c.url) + '">' + mark(c.title, q) + '</a>';
        });
        html += '</div>';
      }
      if (prods.length) {
        prods.forEach(function (p) {
          var img = p.image || '';
          if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=120';
          html += '<a class="gou-sug__item" role="option" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="gou-sug__noimg"></span>') +
            '<span class="gou-sug__text"><span class="gou-sug__title">' + mark(p.title, q) + '</span>' +
            '<span class="gou-sug__price">' + price(p.price) + (p.available === false ? ' &middot; Sold out' : '') + '</span></span></a>';
        });
      } else {
        html += '<p class="gou-sug__none">No pieces match &ldquo;' + esc(q) + '&rdquo; yet.</p>';
      }
      html += '<button type="submit" class="gou-sug__all">See all results for &ldquo;' + esc(q) + '&rdquo; <span aria-hidden="true">&rarr;</span></button>';
      box.innerHTML = html;
      active = -1;
      box.hidden = !focused();
    }

    function run() {
      var q = input.value.trim().toLowerCase().replace(/\s+/g, ' ');
      if (q === current && box.innerHTML) { box.hidden = q.length < 2; return; }
      current = q;
      cats = [];
      remote = null;
      if (q.length < 2) { render(); return; }
      render(); // instant, from the product list if it has loaded
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=10' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,tag';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (q !== current) return;
          var res = (d && d.resources && d.resources.results) || {};
          cats = (res.collections || []).slice(0, 3);
          remote = remoteProducts(q, res);
          render();
        })
        .catch(function () {});
    }

    input.addEventListener('focus', function () {
      loadIndex().then(function () { if (current.length >= 2) render(); });
      if (box.innerHTML && current.length >= 2) box.hidden = false;
    });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 120); });
    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active > -1) {
        var el = items()[active];
        if (el) { e.preventDefault(); e.stopPropagation(); window.location.href = el.getAttribute('href'); }
      }
    }, true);
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  }

  function scan() { document.querySelectorAll('.gou-inline-search__form').forEach(attach); }

  function start() {
    scan();
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 200); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ==========================================================================
   GemofU: home slideshow photos - always the full width of the screen (no
   empty or blurred sides) and the whole piece of jewellery in view with a
   little room around it. For each known photo the band (top and bottom, as
   a share of the photo's height) that holds the jewellery is listed below.
   On a computer the slideshow's height follows the screen's width so the
   band always fits, and each photo is moved so its band sits in view, with
   the empty background above it cut first. Phones keep the theme's crop.
   New hero photos can be added to BANDS; photos not listed are left as
   the theme shows them.
   ========================================================================== */
(function () {
  'use strict';

  var BANDS = {
    '7131.jpg': [0.22, 0.95],                                   // choker + jhumkas
    'generated_20260408091121_ba5b055a.jpg': [0.22, 0.81],      // Lakshmi earrings
    '4721ec065cfc11dc9c928926ca2c9e98d80ec59226a566f169fc5652e571a342_3_afb4effa-9e06-4242-8da1-a5c560843618.png': [0.30, 0.92] // silver pendant
  };
  var PAD = 0.06;          // room around the jewellery, as a share of the photo height
  var MIN_H = 420;

  function bandFor(img) {
    var src = (img.currentSrc || img.src || '').split('?')[0];
    var name = src.substring(src.lastIndexOf('/') + 1);
    return BANDS[name] || null;
  }
  function aspect(img) {
    var nw = img.naturalWidth || parseFloat(img.getAttribute('width')) || 1600;
    var nh = img.naturalHeight || parseFloat(img.getAttribute('height')) || 893;
    return nw / nh;
  }

  function sizeSection(sec) {
    var wrap = sec.closest('.shopify-section') || sec.parentNode;
    sec.classList.remove('gou-hero--card');
    sec.style.removeProperty('max-width');
    if (window.innerWidth < 768) { wrap.style.removeProperty('--desktop-section-height'); return; }
    var W = wrap.clientWidth;
    if (!W) return;
    var need = 0, fullH = Infinity;
    sec.querySelectorAll('.slideshow__slide-image img').forEach(function (img) {
      var band = bandFor(img);
      var Hi = W / aspect(img);
      fullH = Math.min(fullH, Hi);
      if (band) need = Math.max(need, Math.min(1, band[1] - band[0] + PAD) * Hi);
    });
    if (!need) return;
    var H = Math.max(MIN_H, Math.round(Math.min(need, fullH)));
    var cur = wrap.style.getPropertyValue('--desktop-section-height');
    if (cur !== H + 'px') {
      wrap.style.setProperty('--desktop-section-height', H + 'px', 'important');
      var car = sec.querySelector('.flickity-enabled');
      var f = car && window.Flickity && window.Flickity.data ? window.Flickity.data(car) : null;
      if (f && f.resize) { try { f.resize(); } catch (e) {} }
    }
  }

  function place(slide) {
    var img = slide.querySelector('.slideshow__slide-image img');
    if (!img) return;
    img.style.removeProperty('object-position');
    var band = bandFor(img);
    if (!band || window.innerWidth < 768) return;
    var W = slide.clientWidth, H = slide.clientHeight;
    if (!W || !H) return;
    var Hi = W / aspect(img);
    if (Hi <= H) return;
    var t = band[0], b = band[1], need = (b - t) * Hi;
    var crop = need <= H ? t * Hi - (H - need) / 2 : t * Hi + (need - H) / 2;
    crop = Math.max(0, Math.min(Hi - H, crop));
    img.style.setProperty('object-position', '50% ' + (crop / (Hi - H) * 100).toFixed(2) + '%', 'important');
  }

  function all() {
    document.querySelectorAll('.section-slideshow').forEach(sizeSection);
    document.querySelectorAll('.section-slideshow .slideshow__slide').forEach(place);
  }

  var t = null;
  function soon() { clearTimeout(t); t = setTimeout(all, 80); }

  function start() {
    all();
    document.querySelectorAll('.section-slideshow .slideshow__slide-image img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', soon);
    });
    window.addEventListener('resize', soon);
    window.addEventListener('load', soon);
    setTimeout(all, 600);
    setTimeout(all, 1500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ==========================================================================
   GemofU: product photos on a phone - one full-width photo at a time that
   you swipe sideways, with the "‹ 2 / 7 ›" pager under it (like CaratLane),
   instead of every photo stacked down the page. On a computer the same
   photos sit two to a row (assets/gou-photos.css). Picking a
   colour brings that colour's photo (moved to the front by
   assets/gou-v4.js) into view.
   ========================================================================== */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 767px)');
  var CHEV_L = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var rows = [];

  function count(c) {
    return c.querySelectorAll(':scope > .scroll--gallery_item').length;
  }
  function index(c) {
    return c.clientWidth ? Math.round(c.scrollLeft / c.clientWidth) : 0;
  }
  function go(c, i) {
    var n = count(c);
    i = Math.max(0, Math.min(n - 1, i));
    c.scrollTo({ left: i * c.clientWidth, behavior: 'smooth' });
  }

  function setup(c) {
    if (c._gouSwipe) return;
    c._gouSwipe = true;
    var gallery = c.closest('.product-main-images');
    if (gallery) gallery.classList.add('gou-swipe');

    var pager = document.createElement('div');
    pager.className = 'gou-pager gou-pager--swipe';
    pager.innerHTML =
      '<button type="button" class="gou-pager__btn" data-dir="prev" aria-label="Previous photo">' + CHEV_L + '</button>' +
      '<span class="gou-pager__count" aria-live="polite"></span>' +
      '<button type="button" class="gou-pager__btn" data-dir="next" aria-label="Next photo">' + CHEV_R + '</button>';
    c.insertAdjacentElement('afterend', pager);

    function update() {
      var n = count(c);
      pager.hidden = !MQ.matches || n < 2;
      pager.querySelector('.gou-pager__count').textContent = (Math.min(index(c), n - 1) + 1) + ' / ' + n;
    }
    pager.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.gou-pager__btn') : null;
      if (!b) return;
      e.preventDefault();
      go(c, index(c) + (b.getAttribute('data-dir') === 'prev' ? -1 : 1));
    });
    var t = null;
    c.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(update, 60);
    }, { passive: true });
    rows.push({ c: c, update: update });
    update();
  }

  function scan() {
    document.querySelectorAll('.product-main-images .js-scroll-gallery').forEach(setup);
  }

  function refresh() {
    rows.forEach(function (r) { r.update(); });
  }

  // A colour was picked: its photo is moved to the front, so show the first.
  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t || !t.matches || !t.matches('#formVariantId, input[name="id"]')) return;
    setTimeout(function () {
      if (!MQ.matches) return;
      rows.forEach(function (r) {
        if (r.c.querySelector('.gou-first-media')) r.c.scrollTo({ left: 0, behavior: 'smooth' });
      });
    }, 120);
  }, true);

  function start() {
    scan();
    if (MQ.addEventListener) MQ.addEventListener('change', refresh);
    window.addEventListener('resize', refresh);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ==========================================================================
   GemofU: home slideshow photos shown on computers only. A slide whose
   photo is listed here is taken out of the slideshow on phones (the photo
   is wide and the pendant would be tiny). Add more photos by file name.
   ========================================================================== */
(function () {
  'use strict';

  var DESKTOP_ONLY = [];

  function nameOf(img) {
    var src = (img.getAttribute('src') || img.getAttribute('data-src') || img.currentSrc || '').split('?')[0];
    if (!src) {
      var set = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
      src = set.split(' ')[0].split('?')[0];
    }
    return src.substring(src.lastIndexOf('/') + 1);
  }

  function run() {
    if (window.innerWidth >= 768) return true;
    var done = true;
    document.querySelectorAll('.section-slideshow').forEach(function (sec) {
      var car = sec.querySelector('.flickity-enabled');
      var f = car && window.Flickity && window.Flickity.data ? window.Flickity.data(car) : null;
      if (!f || !f.cells) { done = false; return; }
      var gone = [];
      f.cells.forEach(function (cell) {
        var img = cell.element.querySelector('.slideshow__slide-image img') || cell.element.querySelector('img');
        if (img && DESKTOP_ONLY.indexOf(nameOf(img)) !== -1) gone.push(cell.element);
      });
      if (gone.length && gone.length < f.cells.length) {
        f.remove(gone);
        f.select(0, false, true);
      }
    });
    return done;
  }

  function start() {
    if (window.innerWidth >= 768 || run()) return;
    var n = 0;
    var t = setInterval(function () {
      if (run() || ++n > 40) clearInterval(t);
    }, 150);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
